import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import * as LedgerActions from './actions';

import { useDrizzleContext } from "../drizzle/drizzleContext";

import TransactionList from '../list/TransactionList'

import Box from '../components/Box';
import Button from '../components/Button';

import '../css/Ledger.css';
import '../css/LdsDualRing.css';

const LedgerPage = ({
  dispatch,
  accounts,
  synced,
  changingMp,
  dealing,
  gbsTransactions,
  handleSubmit,
  handleChange,
  handleClear,
  handleSubmitW,
  handleChangeW,
  onClickEle,
  onClickDropdown,
  open,
  dealType,
  yt,
  gt,
  vyen,
  tkgbas,
  mp,
  willDealTokens,
  willDealTokensModal,
  willModalConfirm,
  willModalCancel,
  isBalanceOver
}) => {
  const drizzle = useDrizzleContext();
  const [ balanceInEth, setBalanceInEth ] = useState(null);

  const style = isBalanceOver
    ? {  width: '100%', height: '30%', background: '#f0f0f0' }
    : {  width: '100%', height: '20%', background: '#f0f0f0' };
  
  const marketPrices = Array.isArray(mp) ? mp : [];

  const marketPrice =
    marketPrices.length > 0
      ? marketPrices[marketPrices.length - 1]
      : 0;

  const mpChange =
    marketPrices.length > 1
      ? Number(marketPrices[marketPrices.length - 1]) -
        Number(marketPrices[marketPrices.length - 2])
      : 0;

  var dropDownList = [];
  const dealTypeList = [ "PURCHASE", "SELL" ];
  const classNameDtl = open ? 'pv1 tc dropbtn init-bottom-rev mv2' : 'pv1 tc dropbtn init-bottom mv2';

  const [ mpModal, setMpModal ] = useState(null);
  const [ wDTModal, setWDTModal ] = useState(null);

  const PURCHASE = 1;
  const SELL = 2;

  var dealTypeStr = "NODEALTYPE";
  if (dealType === "PURCHASE")
    dealTypeStr = "Purchase"
  else
    dealTypeStr = "Sell"

  dropDownList = dealTypeList.map(i => {
    return (<li key={i} onClick={() => onClickEle(i)}><span>{i}</span></li>);
  });


  const calcEthBalance = async account => {
    const _balanceInWei = await drizzle.web3.eth.getBalance(account);
    const _balance = drizzle.web3.utils.fromWei(_balanceInWei);
    setBalanceInEth(_balance);
    return;
  };

  useEffect(() => {
    const _balance = calcEthBalance(accounts[0]);
    dispatch(refreshedEth());
  }, [synced]);

  useEffect(() => {
    if (changingMp)
      setMpModal(
        <div className='overlay flex flex-column'>
          <div style={{ height: "10%" }}>
            <div className='loader'></div>
          </div>
          <div className='sans-serif gray blinking'>Now changing the market price...</div>
        </div>
      );
    else
      setMpModal(null);
  }, [changingMp]);

  useEffect(() => {
    if (willDealTokensModal)
      setWDTModal(
        <div className='overlay'>
          <div className='modal-ledger flex flex-column justify-center items-center'>
            <Box className='w-100 flex justify-between pv4 pl2'>
              <div className='mh3 mv2 sans-serif f4 fw4 gray'>Confirms Deal</div>
              { dealing &&
              <div className='flex items-center'>
                <div className='flex lds-dual-ring'></div>
                <div className='flex lds-dual-ring-text silver blinking'>This will take several seconds...</div>
              </div>
              }
            </Box>
            { isBalanceOver &&
            <div className='w-90 tc mb3 pt3 pb3 border-red bg-red-100' >
              <span className='text-red-500'>Requested value exceeds the balances of vYen or Token!</span>
            </div>
            }
            <div>
              <table className='w-100 mv2 mh4 bg-black-tr'>
                <tbody>
                  <tr>
                    <td className='sans-serif f5 gray' style={{ width: '224px' }}>Your Address</td>
                    <td className='sans-serif f5 white'>{accounts[0]}</td>
                  </tr>
                  <tr>
                    <td className='sans-serif f5 gray'>Amount</td>
                    <td className='sans-serif f5 white'>{willDealTokens.amount}</td>
                  </tr>
                  <tr>
                    <td className='sans-serif f5 gray'>Price for a Token</td>
                    <td className='sans-serif f5 white'>{willDealTokens.priceForToken}</td>
                  </tr>
                  <tr>
                    <td className='sans-serif f5 gray'>Deal Type</td>
                    <td className='sans-serif f5 white'>{dealTypeStr}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='flex justify-center mt4 mb4'>
            { isBalanceOver || dealing
              ? <Button className='mr1' disabled={true} onClick={willModalConfirm} style={{ width: "128px" }}>Confirm</Button>
              : <Button className='mr1' onClick={willModalConfirm} style={{ width: "128px" }}>Confirm</Button>
            }
            {  dealing
              ? <Button className='ml1' disabled={true} onClick={willModalCancel} style={{ width: "128px" }}>Cancel</Button>
              : <Button className='ml1' onClick={willModalCancel} style={{ width: "128px" }}>Cancel</Button>
            }
            </div>
          </div>
        </div>
      );
    else
      setWDTModal(null);

  }, [willDealTokensModal, dealing]);

  return (
    <div>
      {mpModal}
      {wDTModal}
      <div className='w-100'>
        <Box className='w-95 h-30 ma3 pv3 ph4' style={{ background: "#f0f0f0" }}>
          <h1 className='mv2 sans-serif f4 fw4 greenmod'>Profit and Loss</h1>
          <table>
            <tbody>
              <tr>
                <td className='sans-serif f5 black' style={{ width: '224px' }}>ETH</td>
                <td className='sans-serif f5 greenmod'>{balanceInEth}</td>
              </tr>
              <tr>
                <td className='sans-serif f5' style={{ width: '224px' }}>vYen</td>
                <td className='sans-serif f5 greenmod'>{yt}</td>
              </tr>
              <tr>
                <td className='sans-serif f5'>Token</td>
                <td className='sans-serif f5 greenmod'>{gt}</td>
              </tr>
            </tbody>
          </table>
          <table className='mv2'>
            <tbody>
              <tr>
                <td className='sans-serif f5' style={{ width: '224px' }}>Profit and Loss of vYen</td>
               { vyen >= 0
                 ? <td className='sans-serif f5 greenmod'>{vyen}</td>
                 : <td className='sans-serif f5 red'>{vyen}</td>}
              </tr>
              <tr>
                <td className='sans-serif f5'>Profit and Loss of Token</td>
                { tkgbas >= 0 
                  ? <td className='sans-serif f5 greenmod'>{tkgbas}</td>
                  : <td className='sans-serif f5 red'>{tkgbas}</td>}
              </tr>
            </tbody>
          </table>
          <table>
            <tbody>
              <tr>
                <td className='sans-serif f5' style={{ width: '224px' }}>Market Price</td>
                <td className='sans-serif f5 greenmod'>{marketPrice}</td>
              </tr>
              <tr>
                <td className='sans-serif f5'>Change</td>
                { mpChange >= 0
                  ? <td className='sans-serif f5 greenmod'>{mpChange}</td>
                  : <td className='sans-serif f5 red'>{mpChange}</td>}
              </tr>
            </tbody>
          </table>
        </Box>
        <Box className='w-95 h-30 ma3 pv3 ph4' style={{ background: "#f0f0f0" }}>
          <div>
            <h1 className='mt2 mb2 sans-serif f4 fw4 greenmod'>Makes New Intent</h1>
          </div>
          <div>
            <form onSubmit={(e) => handleSubmitW(e, dealType)}>
              <input
                type="text"
                placeholder="Amount"
                name="amount"
                onChange={handleChangeW}
                className='v-mid focus-outline mb1'
                style={{ borderColor: '#ffffff', width: '27%', maxWidth: "400px" }}
              />
              <input
                type="text"
                placeholder="Price for a Token"
                name="priceForToken"
                onChange={handleChangeW}
                className='v-mid focus-outline mb1'
                style={{ borderColor: '#ffffff', width: '27%', maxWidth: "400px" }}
              />
              <div className='dropdown'>
                <div onClick={onClickDropdown} className={classNameDtl} style={{ width: '22.5%', fontWeight: '400' }}>{dealType}</div>
                { open && (<div className='dropdown-content'>
                  <ul>
                    {dropDownList}
                    </ul>
                  </div>)}
              </div>
              <Button type="submit" className='mv2 fw1' style={{ fontWeight: '400' }}>Submit</Button>
            </form>
          </div>
        </Box>
        <Box className='w-95 h-30 ma3 pv3 ph4' style={{ background: "#f0f0f0" }}>
          <div>
            <h1 className='mt2 mb2 sans-serif f4 fw4 greenmod'>Transaction History</h1>
          </div>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Start time"
              name="startTime"
              onChange={handleChange}
              className='v-mid focus-outline mb1'
              style={{padding: '1px', borderColor: '#ffffff', width: '27%', maxWidth: "400px" }}
            />
            <input
              type="text"
              placeholder="End time"
              name="endTime"
              onChange={handleChange}
              className='v-mid focus-outline mb1'
              style={{padding: '1px', borderColor: '#ffffff', width: '27%', maxWidth: "400px" }}
            />
            <Button type="submit" className='mb1 fw1' style={{ fontWeight: '400' }}>Search</Button>
          </form>
          <form onSubmit={handleClear}>
            <Button type="clear" className='mv2' style={{ fontWeight: '400' }}>Clear Result</Button>
          </form>
          <div className='sans-serif mv2'>Start time and End time must be multiplications of 30 minutes, yyyy/mm/dd HH:MM:SS.</div>
        </Box>
        <TransactionList
          gbsTransactions={gbsTransactions}
        />
      </div>
    </div>
  );
}

const refreshedEth = () => {
  return {
    type: LedgerActions.ETH_REFRESHED
  }
}

const mapStateToProps = state => ({
  accounts: state.accounts,
  synced: state.ledger.synced,
  changingMp: state.ledger.changingMp,
  dealing: state.ledger.dealing
});

export default connect(mapStateToProps)(LedgerPage);
